import React from "react";
import { Modal } from "antd";
import { CiCreditCard1 } from "react-icons/ci";
import { FaRegBuilding, FaRegCalendarAlt } from "react-icons/fa";
import { FiAlertTriangle } from "react-icons/fi";
import { RiMoneyDollarCircleLine } from "react-icons/ri";

import * as Style from "../../style";
import { TModalListAllLaunches } from "./types";

const ModalListAllLaunches: React.FC<TModalListAllLaunches> = ({
  faturaSelected,
  infosFullFatura,
  isModalLancamentosOpen,
  setIsModalLancamentosOpen,
}) => {
  return (
    <Modal
      title={`Lançamentos de ${faturaSelected?.MesVencimento}/${faturaSelected?.anoVencimento}`}
      visible={isModalLancamentosOpen}
      onCancel={setIsModalLancamentosOpen}
      width={795}
    >
      <Style.WrapperFaturaV2>
        <div className="fatura-v2__table">
          <div className="fatura-v2__table--header">
            <div className="fatura-v2__table--header__data">
              <p>Data</p>
            </div>
            <div className="fatura-v2__table--header__local">
              <p>Local</p>
            </div>
            <div className="fatura-v2__table--header__cartao">
              <p>Cartão truncado</p>
            </div>
            <div className="fatura-v2__table--header__real">
              <p>Valor em Real</p>
            </div>
          </div>

          {infosFullFatura?.lancamentos?.map((item, index) => (
            <div
              className={`fatura-v2__table--item ${item.tipo} ${
                index === 0 ? "first" : ""
              }`}
              key={Math.random()}
            >
              <div className="item-data">
                <FaRegCalendarAlt />

                <p>{item.dataTransacao}</p>
              </div>
              <div className="item-info">
                {item.tipo === "PAGAMENTO" ? <RiMoneyDollarCircleLine /> : ""}
                {item.tipo === "VENDA" ? <FaRegBuilding /> : ""}
                {item.tipo === "AJUSTE" ? <FiAlertTriangle /> : ""}
                <p>{item.descricaoLancamento}</p>
              </div>
              <div className="item-cartao-truncado">
                {item.numeroCartaoTruncado && (
                  <>
                    <CiCreditCard1 fontSize={16} />
                    {item.numeroCartaoTruncado}
                  </>
                )}
              </div>
              <div className="item-dinheiro">
                <p>{item.valor}</p>
              </div>
            </div>
          ))}
        </div>
      </Style.WrapperFaturaV2>
    </Modal>
  );
};

export default ModalListAllLaunches;
